<template>
  <div class="card summary-card">
    <div class="card-body">
      <p class="card-title">{{ metric.title }}</p>
      <div class="metric-value" :class="statusClass">
        {{ metric.value }}{{ metric.unit }}
      </div>
      <p class="card-text"><small>Threshold: {{ thresholdText }}</small></p>
      <div class="progress">
        <div
          class="progress-bar"
          :class="progressBarClass"
          :style="progressBarStyle"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryCard',
  props: {
    metric: {
      type: Object,
      required: true
    }
  },
  computed: {
    // New condition: if a higher threshold is defined and exceeded
    exceedsHigherThreshold() {
      return (
        this.metric.higherthreshold === true &&
        this.metric.value >= this.metric.higherthresholdvalue
      );
    },
    // Original threshold logic
    meetsThreshold() {
      if (this.metric.comparison === 'higher') {
        return this.metric.value >= this.metric.threshold;
      }
      return this.metric.value <= this.metric.threshold;
    },
    // Determine text color class
    statusClass() {
      if (this.exceedsHigherThreshold) {
        return { 'text-danger': true };
      }
      return {
        'text-success': this.meetsThreshold,
        'text-warning': !this.meetsThreshold && this.metric.comparison === 'lower',
        'text-danger': !this.meetsThreshold && this.metric.comparison === 'higher'
      };
    },
    // Format threshold text
    thresholdText() {
      const operator = this.metric.comparison === 'higher' ? '>' : '<';
      return `${operator} ${this.metric.threshold}${this.metric.unit}`;
    },
    // Determine progress bar color
    progressBarClass() {
      if (this.exceedsHigherThreshold) {
        return { 'bg-danger': true };
      }
      return {
        'bg-success': this.meetsThreshold,
        'bg-warning': !this.meetsThreshold && this.metric.comparison === 'lower',
        'bg-danger': !this.meetsThreshold && this.metric.comparison === 'higher'
      };
    },
    // Compute bar width
    progressBarStyle() {
      let percentage;
      // Same formula works for both comparisons
      percentage = Math.min(
        100,
        (this.metric.value / this.metric.threshold) * 100
      );
      return { width: percentage + '%' };
    }
  }
};
</script>

<style scoped>
.summary-card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.summary-card:hover {
  transform: translateY(-5px);
}

.metric-value {
  font-size: 2rem;
  font-weight: bold;
  margin: 10px 0;
}

.status-icon {
  font-size: 1.5rem;
  vertical-align: middle;
  margin-left: 10px;
}

.progress-bar {
  height: 0.5rem !important;
  border-radius: 5px;
}

.progress {
  display: flex;
  height: 0.5rem !important;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}
.card-title{
  font-size: .9rem !important;
  font-weight: 600 !important;
}
</style>
